import { Button, Input, Popconfirm, Select, Space, message } from 'antd'
import React from 'react'
import { Text } from '../../../../styles/reactnative'
import API from '../../../../utils/api'
import ExchangeName from '../../ExchangeName'
import Price from '../../PositionColumns/Price'
import PSlipage from 'app/components/PSlipage'

export const column_ovs_person = (
	mutate,
	usermodal,
	token,
	fold,
	edit,
	setEdit,
	shareMutate,
	uid,
	setSC,
	level
) => {
	let editable = false

	return [
		{
			title: '구분코드',
			dataIndex: 'code',
			align: 'center',
			key: 'code',
			width: 80,
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '구분이름',
			dataIndex: 'groupname',
			key: 'groupname',
			align: 'center',
			render: (text, record) => {
				return <Text style={{ fontWeight: 'bold' }}>{text}</Text>
			},
		},
		{
			title: '거래소',
			dataIndex: 'exchange_id',
			align: 'center',
			key: 'exchange_id',
			render: (text, record) => {
				return <ExchangeName exchange_id={text} />
			},
		},
		{
			title: '종목코드',
			dataIndex: 'pairs',
			key: 'pairs',
			render: (text, record) => {
				return (
					<Text
						style={{
							backgroundColor: record?.person
								? 'lightblue'
								: 'white',
						}}>
						{text}
					</Text>
				)
			},
		},
		{
			title: '증거금',
			align: 'center',
			children: [
				{
					title: '증거금',
					dataIndex: 'minimum_margin',
					align: 'center',
					key: 'minimum_margin',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.minimum_margin = e.target.value
								}}
							/>
						) : (
							<Price price={text} dp={0} />
						)
					},
				},
				{
					title: '로스컷',
					dataIndex: 'losscut',
					align: 'center',
					key: 'losscut',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.losscut = e.target.value
								}}
							/>
						) : (
							<Price price={text} dp={0} />
						)
					},
				},
				{
					title: '오버나잇',
					dataIndex: 'ovn_margin',
					align: 'center',
					key: 'ovn_margin',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.ovn_margin = e.target.value
								}}
							/>
						) : (
							<Price price={text} dp={0} />
						)
					},
				},
				{
					title: '최대계약수',
					dataIndex: 'max_amount',
					align: 'center',
					key: 'max_amount',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.max_amount = e.target.value
								}}
							/>
						) : (
							<Text>{text}</Text>
						)
					},
				},
			],
		},
		{
			title: '수수료',
			align: 'center',
			children: [
				{
					title: '수수료',
					dataIndex: 'fee',
					align: 'right',
					key: 'fee',
					render: (text, record) => {
						return record?.edit ? (
							<Input
								size="small"
								defaultValue={text}
								type="number"
								onChange={e => {
									record.fee = e.target.value
								}}
							/>
						) : (
							<Text>{text}</Text>
						)
					},
				},
				{
					title: '단위',
					dataIndex: 'feetype',
					align: 'left',
					width: 80,
					key: 'feetype',
					render: (text, record) => {
						return record?.edit ? (
							<Select
								defaultValue={text}
								size="small"
								options={[
									{ value: 0, label: '%' },
									{ value: 1, label: record?.feecurrency },
								]}
								onChange={e => {
									record.feetype = e
								}}
							/>
						) : (
							<Text>{text == 0 ? '%' : record?.feecurrency}</Text>
						)
					},
				},
				{
					title: '슬리피지',
					dataIndex: 'slip',
					align: 'left',
					width: 80,
					key: 'slip',
					render: (text, record) => {
						return <PSlipage user_id={uid} ep_id={record?.id} />
					},
				},
			],
		},
		{
			title: '관리',
			align: 'center',
			render: (text, record) => {
				return (
					<Space.Compact size="small">
						{level == 99 && (
							<Button
								type="primary"
								size="small"
								onClick={() => {
									if (!record?.edit) {
										record.edit = record.edit ? false : true
										setEdit(!edit)
									} else {
										API.send(
											'PUT',
											'/admin/grouppairsnotset',
											token,
											{
												//ov, adminname, isactive, margin, losscut, ovnmargin, max_amount, fee, feetype
												ov: record?.pairs,
												margin: record?.minimum_margin,
												losscut: record?.losscut,
												ovnmargin: record?.ovn_margin,
												max_amount: record?.max_amount,
												fee: record?.fee,
												feetype: record?.feetype,
												slip: record?.slip,
											}
										).then(res => {
											record.edit = record.edit
												? false
												: true
											setEdit(!edit)
											message.success('수정되었습니다.')
											mutate(1)
											shareMutate(1)
										})
									}
								}}>
								그룹일괄
							</Button>
						)}

						<Button
							type="primary"
							size="small"
							onClick={() => {
								if (!record?.edit) {
									record.edit = record.edit ? false : true
									setEdit(!edit)
								} else {
									API.send(
										'PUT',
										'/admin/personpairs',
										token,
										{
											//ov, adminname, isactive, margin, losscut, ovnmargin, max_amount, fee, feetype
											ov: record?.pairs,
											userid: uid,
											margin: record?.minimum_margin,
											losscut: record?.losscut,
											ovnmargin: record?.ovn_margin,
											max_amount: record?.max_amount,
											fee: record?.fee,
											feetype: record?.feetype,
											slip: record?.slip,
										}
									).then(res => {
										record.edit = record.edit ? false : true
										setEdit(!edit)
										message.success('수정되었습니다.')
										mutate(1)
										shareMutate(1)
									})
								}
							}}>
							수정
						</Button>
						<Popconfirm
							title={'개별설정을 삭제하시겠습니까?'}
							onConfirm={() => {
								API.delete('/admin/personpairs', token, {
									ov: record?.pairs,
									userid: uid,
								}).then(res => {
									message.success('삭제되었습니다.')
									setEdit(!edit)
									mutate(1)
									shareMutate(1)
								})
							}}>
							<Button type="primary" size="small" danger>
								삭제
							</Button>
						</Popconfirm>
					</Space.Compact>
				)
			},
		},
	]
}
